export interface PlantStation {
  id: string;
  name: string;
}

export interface PlantLine {
  id: string;
  name: string;
  stations: PlantStation[];
}

export interface Plant {
  id: string;
  name: string;
  lines: PlantLine[];
}

export const MOCK_PLANT_CATALOG: Plant[] = [
  {
    id: 'MDC-01',
    name: 'Planta MDC-01',
    lines: [
      {
        id: 'LINE-A',
        name: 'Línea A',
        stations: [
          { id: 'ST-A1', name: 'Estación A1' },
          { id: 'ST-A2', name: 'Estación A2' },
          { id: 'ST-A3', name: 'Estación A3' },
        ],
      },
      {
        id: 'LINE-B',
        name: 'Línea B',
        stations: [
          { id: 'ST-B1', name: 'Estación B1' },
          { id: 'ST-B2', name: 'Estación B2' },
        ],
      },
    ],
  },
  {
    id: 'MDC-02',
    name: 'Planta MDC-02',
    lines: [
      {
        id: 'LINE-C',
        name: 'Línea C',
        stations: [
          { id: 'ST-C1', name: 'Estación C1' },
          { id: 'ST-C2', name: 'Estación C2' },
        ],
      },
      {
        id: 'LINE-D',
        name: 'Línea D',
        stations: [
          { id: 'ST-D1', name: 'Estación D1' },
        ],
      },
    ],
  },
];
